/* eslint-disable camelcase */
import { type UseMutationResult, useMutation, useQueryClient } from 'react-query';
import { toast } from 'react-toastify';
import ToastComponent from '../../components/toast';
import {
  ProductionService,
  Wealthlane_Dtos_Production_ProductionResponseDto,
} from '../../services/wealthlane-identity-services';

const usePostPushToProduction = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>,
  closeModal: () => void
): UseMutationResult<
  Wealthlane_Dtos_Production_ProductionResponseDto | undefined,
  unknown,
  any,
  unknown
> => {
  const queryClient = useQueryClient();
  return useMutation(
    async (payload: any) => {
      return await handleRequest(ProductionService.postApiIdentityApiProduction(payload));
    },
    {
      onSuccess: (response: any) => {
        if (response != null) {
          void queryClient.invalidateQueries('getSandboxProductionList');
          closeModal();
          toast.success(<ToastComponent label='Success' message='Sandbox Pushed to Production.' />);
        }
      },
      onError: (err) => {
        console.log('error', err);
      },
    }
  );
};

export default usePostPushToProduction;
